<template>
  <div class="item-container">
    <div :class={WPOffset:isWPOffset} class="ust-item">
      <div class="ust-item-box" :class = "addClass"></div>
      <div class="ust-item-title">{{title}}</div>
      <div :class={valPosition:isWPOffset} class="ust-item-val">{{value}} {{unitLabelVal}}</div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: ['title', 'value', 'addClass', 'isWPOffset', 'isCeilingHeight'],
  data () {
    return {}
  },
  filters: {
    filterFeet (value) {
      return this.isCeilingHeight && value === 'inch' ? 'ft' : value
    }
  },
  computed: {
    ...mapState(['unit']),
    ...mapGetters(['unitLabel']),
    unitLabelVal () {
      return this.isCeilingHeight && this.fd === 'inch' ? 'ft' : this.unitLabel
    }

  },
  watch: {},
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style scoped>
.item-container {
  display: flex;
}
.ust-item {
  width: 180px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  margin-bottom: 2px;
  padding: 5px 10px 5px 7px;
  font-size: 14px;
  position: relative;
  z-index: 10
}
.WPOffset{
  width: 220px;
  /* height: 160px; */
}
.ust-item-box {
  height: 100%;
  width: 6px;
  float: left;
}
.ust-item-title {
  padding-left: 12px;
  padding-top: 5px;
  line-height: 16px;
}
.ust-item-val {
  font-weight: bold;
  text-align: right;
}
.valPosition {
  bottom: 95px;
}
.param-color {
  background: #008000;
}
.screen-to-wall-color {
  background: #7b68ee;
}
.ceiling-height-color {
  background: #191970;
}
.wall-to-pjfront-color {
  background: #00bfff;
}
.wallplate-offset-color{
  background: #ff1493;
}
img{
  position: relative;
  top: 7px;
  left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/UST/USTItem.vue